(function() {
  const zoomContainer = document.querySelector('.new-pdp--image-zoom-container');
  const normalImage = document.querySelector('.new-pdp--image-normal');
  const zoomedImage = document.querySelector('.new-pdp--image-zoomed');

  if (!zoomContainer || !normalImage || !zoomedImage) return;

  // State
  let isZoomEnabled = true; // Default: Zoom functionality is active
  let isHovering = false;   // Track if mouse is currently over the container

  // Configuration
  const zoomedFactor = 2; // Matches CSS width: 200%

  // Helper to update visibility based on state
  function updateVisibility() {
    // Zoom shows ONLY if we are hovering AND zoom is enabled
    if (isHovering && isZoomEnabled) {
      zoomedImage.style.opacity = '1';
      normalImage.style.opacity = '0';
      zoomedImage.style.pointerEvents = 'auto'; // Necessary to capture clicks if overlaying? Actually better 'none' to let container capture or 'auto' on container
    } else {
      zoomedImage.style.opacity = '0';
      normalImage.style.opacity = '1';
      zoomedImage.style.pointerEvents = 'none';
      if(!isHovering) {
         // Reset transform when leaving for cleaner re-entry?
         // Optional, but usually nice.
      }
    }
  }

  // Mouse Move: Pan the zoomed image
  zoomContainer.addEventListener('mousemove', function(e) {
    if (!isZoomEnabled) return; // Optimization: don't calc if disabled

    // Calculate position
    const containerRect = zoomContainer.getBoundingClientRect();
    const normalRect = normalImage.getBoundingClientRect();

    // Mouse position relative to the image
    const mouseX = e.clientX - normalRect.left;
    const mouseY = e.clientY - normalRect.top;

    // Logic:
    // We want the point under the mouse on the normal image
    // to match the point under the mouse on the zoomed image.
    // Since zoomed image is 2x, we simply move it carefully.

    // The existing logic provided in the file seemed to work for the user,
    // likely mapping mouse movement to translate percentage.
    // Let's preserve the specific math style but ensure it's robust.

    // Simplest approach for 200% zoom (factor 2):
    // If mouse is at 0% x (left), we want zoomed image left at 0.
    // If mouse is at 100% x (right), we want zoomed image right at 100% (which means translate -50% if width is 200%... wait).

    // Let's stick to the previous math logic if it was working or use a standard standard approach.
    // Previous code:
    // const xDifference = mouseX - (mouseX * 2) = -mouseX
    // translateX = (-mouseX / zoomedImage.width) * 100

    // Let's derive simpler percentage based math.
    const xPercent = (mouseX / normalRect.width) * 100;
    const yPercent = (mouseY / normalRect.height) * 100;

    // If mouse is at 0%, transform should be 0%.
    // If mouse is at 100%, transform should be (100% - 200%)/1 = -100%? No.
    // If container width is W. Zoom width is 2W.
    // We want to show the range [0, W].
    // At x=0, we show [0, W] of the zoomed image (left aligned). Transform 0.
    // At x=W, we show [W, 2W] of the zoomed image (right aligned). Transform -W (which is -50% of 2W).

    // Translation X = - (xPercent / 100) * (ZoomWidth - ContainerWidth)
    // ZoomWidth = 200%, ContainerWidth = 100%. Diff = 100%.
    // Translation X in % of Container = -xPercent.
    // Translation X in % of ZoomElement (which is 2x container) = -xPercent / 2.

    // Let's verify the previous math: `xDifference = -mouseX`. `xPercent = (-mouseX / zoomedWidth)*100`.
    // zoomedWidth is approx 2 * normalWidth.
    // so `(-mouseX / (2*normalWidth)) * 100` = `-0.5 * (mouseX/normalWidth)*100` = `-0.5 * xPercentOfTheNormalImage`.
    // Valid.

    // I will use percentage based calculation for responsiveness.
    const x = (mouseX / normalRect.width) * 100;
    const y = (mouseY / normalRect.height) * 100;

    // Transform percentage: range from 0 to -50% (relative to self width 200%)
    // But translate(%) usually refers to self dimensions.
    // At 0% input -> 0% translate.
    // At 100% input -> -50% translate (to show the right half).

    const xTranslate = -x / 2;
    const yTranslate = -y / 2;

    zoomedImage.style.transform = `translate(${xTranslate}%, ${yTranslate}%)`;
  });

  // Toggle Functionality
  zoomContainer.addEventListener('click', function(e) {
    e.preventDefault();
    // Do not stop propagation if other things need click, but here likely fine.

    isZoomEnabled = !isZoomEnabled;
    updateVisibility();
  });

  // Hover Handlers
  zoomContainer.addEventListener('mouseenter', function() {
    isHovering = true;
    isZoomEnabled = true; // Reset state on re-entry
    updateVisibility();
  });

  zoomContainer.addEventListener('mouseleave', function() {
    isHovering = false;
    updateVisibility();
  });

})();
